'use client';

import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import { getDelegateAccountLabel } from 'src/utils/account';
import { abbreviateAddress } from 'src/utils/strings';
import { useDrawersStore } from 'src/stores/useDrawersStore';
import { cj } from 'src/utils/classNames';
import useModal from 'src/components/Modals/hooks/useModal';
import TopBarWalletButtonIcon from 'src/components/TopBar/TopBarWalletButtonIcon';
import Button from 'src/components/primitives/Button/Button';
import useDriftAccountStore from 'src/stores/useDriftAccountsStore';
import { TOP_BAR_DEFAULT_BUTTON_CLASSNAME } from 'src/components/TopBar/consts';

const DATA_TEST_ID = 'wallet_button';

export default function TopBarWalletButton() {
	const setDrawersState = useDrawersStore((s) => s.set);
	const isAccountsSidebarOpen = useDrawersStore((s) => s.accounts.show);
	const walletIsConnected = useDriftStore(
		(s) => s.wallet.current?.adapter?.connected
	);
	const walletPubKey = useDriftStore(
		(s) => s.wallet.current?.adapter?.publicKey
	);
	const currentAccount = useDriftAccountStore(
		(s) => s.accounts[s.currentUserKey ?? '']
	);
	const { show } = useModal();

	const handleShowConnectWalletOptions = () => {
		show({ type: 'connect_wallet', props: {} });
	};

	const handleConnectedButtonClick = () => {
		setDrawersState((s) => {
			if (isAccountsSidebarOpen) {
				s.accounts.show = false;
			} else {
				s.accounts.show = true;
			}
		});
	};

	const remountKey = walletIsConnected ? 'connected' : 'disconnected';

	if (!walletIsConnected || !walletPubKey) {
		return (
			<Button
				size="md"
				onClick={handleShowConnectWalletOptions}
				key={remountKey}
				dataTestId={DATA_TEST_ID}
			>
				Connect
			</Button>
		);
	}

	const accountName = currentAccount?.isDelegatedTo
		? getDelegateAccountLabel(currentAccount)
		: (currentAccount?.name ?? '');

	return (
		<Button
			size="md"
			variant="stroke"
			className={cj(
				'h-full gap-x-sm overflow-hidden py-xs',
				TOP_BAR_DEFAULT_BUTTON_CLASSNAME
			)}
			onClick={handleConnectedButtonClick}
			dataTestId={DATA_TEST_ID}
			key={remountKey}
		>
			<TopBarWalletButtonIcon />
			<div className="flex flex-col items-start typo-b5 text-text-default">
				<span className="max-w-18 truncate whitespace-nowrap">
					{accountName}
				</span>
				<span className="whitespace-nowrap text-text-secondary">
					{abbreviateAddress(walletPubKey)}
				</span>
			</div>
		</Button>
	);
}
